import * as React from 'react';
import type { SVGProps } from 'react';

const IconAdded = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <rect x="1.5" y="1.003" width="13" height="13" rx="6.5" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.264 5.626-5.717 5.116-2.812-2.516.588-.658 2.224 1.99 5.129-4.59.588.658Z"
      fill="#fff"
    />
  </svg>
);
export default IconAdded;
